/**
 * Bilingual copy for the Blog listing page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  title: 'AKAS Blogs | Business Cloud Solutions',
  description:
    'Insights on AKAS cloud ERP — HR, CRM, sales, revenues, purchases, expenses, and accounting.',
  heading: 'Blog',
  searchPlaceholder: 'Search',
  loading: 'Loading blog posts...',
  noResults: 'No blog posts found',
  noResultsHint: 'Try a different search term or check back later for new content.',
};

export type Copy = typeof en;

export const km: Copy = {
  title: 'ប្លុក AKAS | ដំណោះស្រាយ Cloud សម្រាប់អាជីវកម្ម',
  description:
    'អត្ថបទអំពី AKAS Cloud ERP — ធនធានមនុស្ស, ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន, ការលក់, ការគ្រប់គ្រងចំណូល, ការទិញ, ចំណាយ និងគណនេយ្យ។',
  heading: 'ប្លុក',
  searchPlaceholder: 'ស្វែងរក',
  loading: 'កំពុងផ្ទុកអត្ថបទប្លុក...',
  noResults: 'រកមិនឃើញអត្ថបទប្លុកទេ',
  noResultsHint: 'សូមព្យាយាមពាក្យស្វែងរកផ្សេងទៀត ឬត្រឡប់មកពិនិត្យឡើងវិញនៅពេលក្រោយសម្រាប់ខ្លឹមសារថ្មី។',
};
